import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Page } from '../models/page-wrapper.model';
import { ContractCalculation } from './contract-calculation.model';
// import { ContractAttachment } from './contract-attachment.model';

@Injectable({
  providedIn: 'root',
})
export class ContractCalculationService {
  private apiUrl = `${environment.restApiUrl}contractCalculation`;

  constructor(private http: HttpClient) {}

  searchContractCalculations(
    params: HttpParams
  ): Observable<ContractCalculationSearchResponse> {
    return this.http.get<ContractCalculationSearchResponse>(
      this.apiUrl + '/search',
      {
        params,
      }
    );
  }

  // generateContractCalculation(
  //   params: HttpParams
  // ): Observable<ContractCalculation> {
  //   return this.http.get<ContractCalculation>(this.apiUrl + '/generateAR', {
  //     params,
  //   });
  // }
  generateContractCalculation(
    params: HttpParams,
    extraData: any
  ): Observable<ContractCalculation> {
    return this.http.post<ContractCalculation>(
      this.apiUrl + '/generateAR',
      extraData,
      {
        params,
      }
    );
  }

  generateClaimCalculation(
    params: HttpParams,
    extraData: any
  ): Observable<ContractCalculation> {
    return this.http.post<ContractCalculation>(
      this.apiUrl + '/generateAP',
      extraData,
      {
        params,
      }
    );
  }

  issueToSupplier(
    params: HttpParams,
  ): Observable<ContractCalculation> {
    return this.http.post<ContractCalculation>(
      this.apiUrl + '/issueToSupplier',   
      [],
      {
        params,
      }
    );
  }
  
  bookJV(
    params: HttpParams,
    extraData: any
  ): Observable<ContractCalculation> {
    return this.http.post<ContractCalculation>(
      this.apiUrl + '/jvBooked',
      extraData,
      {
        params,
      }
    );
  }
  jvReversalBooked(
    params: HttpParams,
    extraData: any
  ): Observable<ContractCalculation> {
    return this.http.post<ContractCalculation>(
      this.apiUrl + '/jvReversed',
      extraData,
      {
        params,
      }
    );
  }

  // Update rebate amount for a specific calculation line
  updateRebateAmount(
    lineId: number,
    rebateAmount: number
  ): Observable<ContractCalculation> {
    const body = { lineId: lineId, rebateAmount: rebateAmount };
    return this.http.post<ContractCalculation>(
      `${this.apiUrl}/update/rebateAmount`,
      body
    );
  }
  // Update rebate amount for a specific calculation line
  updateClaimAmount(
    lineId: number,
    claimAmount: number
  ): Observable<ContractCalculation> {
    const body = { lineId: lineId, claimAmount: claimAmount };
    return this.http.post<ContractCalculation>(
      `${this.apiUrl}/update/claimAmount`,
      body
    );
  }
}

export interface ContractCalculationSearchResponse {
  lines: Page<ContractCalculation>;
  totalClaimAmt: number;
}
